module.exports = {
  ALL_YOU_CAN_EAT: 'ALL_YOU_CAN_EAT',
  ALL_YOU_CAN_DRINK: 'ALL_YOU_CAN_DRINK',
  HAPPY_HOUR: 'HAPPY_HOUR',
  PACKAGE_MENU_DEFAULT_FOOD_ITEM_CODE: 'pkg_item',
};
